import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RSVPInvitationPage_pooja } from "../../RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";
import { uploadImage } from "../../../Apiservices/Auth/servers/profileServer";

const ChooseTemplateDialog = ({
  visible,
  onHide,
  selectedTemplate,
  setSelectedTemplate,
  selectedTemplateError,
  handleTemplateSubmit,
  imageloading,
  eventimages = [],
  currentIndex = 0,
  handlePrev,
  handleNext,
  imagetemplateslength,
  EventDataForInvitation,
  loadingOverlay,
}) => {
  const fileInputRef = useRef(null);
  const [customTemplate, setCustomTemplate] = useState(null);
  const [uploadingCustom, setUploadingCustom] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    try {
      setUploadingCustom(true);
      const fileId = await uploadImage(file);
      const blobUrl = URL.createObjectURL(file);
      setCustomTemplate({ id: fileId, url: blobUrl, name: fileId });
    } catch (err) {
      console.error("Failed to upload custom template image:", err);
    } finally {
      setUploadingCustom(false);
    }
  };

  const displayImageUrl = customTemplate
    ? customTemplate.url
    : eventimages[currentIndex]?.url;

  return (
    <Dialog
      header={<div className="template-dialog-header-title">Choose the Template</div>}
      visible={visible}
      modal
      onHide={() => {
        setCustomTemplate(null);
        onHide();
      }}
      className="template-dialog"
    >
      {loadingOverlay ? (
        <div
          style={{
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
          <p style={{ marginTop: "8px" }}>Preparing templates...</p>
        </div>
      ) : imageloading ? (
        <h3 style={{ textAlign: "center" }}>
          <i
            className="pi pi-spin pi-spinner-dotted"
            style={{ fontSize: "2rem", color: "#0cc0df" }}
          ></i>
        </h3>
      ) : (
        <>
          {/* Image counter / Custom Template Notice */}
          <div className="image-counter" style={{ textAlign: "center" }}>
            {customTemplate ? (
              <span style={{ color: "#0cc0df", fontWeight: 600 }}>Custom Template Selected</span>
            ) : (
              eventimages.length > 0
                ? `${currentIndex + 1} / ${eventimages.length}`
                : 'No templates loaded'
            )}
          </div>

          {!customTemplate && eventimages.length === 0 ? (
            <p role="alert">Invitation templates could not be loaded. Close this window and open Send Invitation again to retry.</p>
          ) : <div className="image-preview">
            <div className="single-image-container">
              {/* Preview */}
              <div style={{ pointerEvents: "none", userSelect: "none" }}>
                <div className="rsvp-wrapper-scaled">
                  <div className="rsvp-scaled-inner">
                    <RSVPInvitationPage_pooja
                      EventDataForInvitation={EventDataForInvitation}
                      imageUrl_as_prop={displayImageUrl}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Template Disclaimer */}
            <div className="template-disclaimer">
              <i className="pi pi-info-circle" style={{ fontSize: "1rem" }}></i>
              <span>Note: This is an invitation template preview and cannot be filled out directly.</span>
            </div>
          </div>}

          {/* Navigation arrows & Actions */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "14px",
              marginTop: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "16px",
                width: "100%",
              }}
            >
              <div className="arrow-controls">
                {!customTemplate && eventimages.length > 1 && (
                  <Button
                    icon="pi pi-chevron-left"
                    onClick={handlePrev}
                    className="arrow-button"
                  />
                )}
              </div>

              <Button
                label="Select this template"
                disabled={!customTemplate && eventimages.length === 0}
                className="select-template-btn"
                onClick={() => {
                  console.log("clicked template");
                  if (customTemplate) {
                    handleTemplateSubmit(customTemplate.name || customTemplate.id);
                  } else if (eventimages.length === 0) {
                    handleTemplateSubmit("");
                  } else {
                    const chosen = eventimages[currentIndex]?.name;
                    handleTemplateSubmit(chosen);
                  }
                }}
              />

              <div className="arrow-controls">
                {!customTemplate && eventimages.length > 1 && (
                  <Button
                    icon="pi pi-chevron-right"
                    onClick={handleNext}
                    className="arrow-button"
                  />
                )}
              </div>
            </div>

            {/* Custom Template Upload Section */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "4px" }}>
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <Button
                label={uploadingCustom ? "Uploading..." : "Upload My Custom Design Invitation"}
                icon={uploadingCustom ? "pi pi-spin pi-spinner" : "pi pi-upload"}
                className="custom-upload-btn"
                disabled={uploadingCustom}
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
              />
              {customTemplate && (
                <Button
                  label="Clear Custom"
                  icon="pi pi-times"
                  className="p-button-text p-button-danger p-button-sm"
                  onClick={() => setCustomTemplate(null)}
                />
              )}
            </div>
          </div>
        </>
      )}
    </Dialog>
  );
};

export default ChooseTemplateDialog;

